import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../lib/firebase.js';
import AuthHeader from './AuthHeader.jsx';
import SEO from '../components/SEO.jsx';
import PublicFonts from '../components/PublicFonts.jsx';
import './landing.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
      navigate('/');
    } catch (err) {
      setError(prettyAuthError(err.code) || 'Sign in failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="lp3 lp3-auth auth-shell">
      <SEO title="Sign in" noIndex />
      <PublicFonts />
      <form className="auth-card" onSubmit={onSubmit}>
        <AuthHeader />
        <h1>Sign in</h1>
        <p className="subtitle">Welcome back to Giraops.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email" type="email" autoComplete="email" required
          value={email} onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Password</label>
        <input
          id="password" type="password" autoComplete="current-password" required
          value={password} onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        {error && <div className="error">{error}</div>}

        <div className="footer">
          <Link to="/reset" className="auth-link">Forgot password?</Link>
          <span style={{ margin: '0 10px' }}>·</span>
          <Link to="/signup" className="auth-link">Create account</Link>
        </div>
      </form>
    </div>
  );
}

function prettyAuthError(code) {
  switch (code) {
    case 'auth/invalid-email':
    case 'auth/invalid-credential':
    case 'auth/user-not-found':
    case 'auth/wrong-password':
      return 'Invalid email or password.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait and try again.';
    default:
      return null;
  }
}
